import { checkIfStoreIsNotPermanentlyClosed } from '@api/interfaces/storeApi';
import { useEffect } from 'react';
import useCustomer from '@hooks/useCustomer';
import useLocalStorage from '@hooks/useLocalStorage';
import config from '@config';
import useAbortController from '@hooks/useAbortController';

const useStoreAndLocaleState = (getStoreAndSetLocalState: (id: string) => void) => {
  const { customer } = useCustomer();
  const [promotionStoreId, setPromotionStoreId] = useLocalStorage(config.LOCAL_STORAGE_SELECTORS.promotionStoreId, '');
  const { getSignal } = useAbortController();
  const getStoreAndSetLocalStateFromLocalStorage = async () => {
    const offlineStoreId = promotionStoreId || customer?.homeStoreId;
    if (offlineStoreId) {
      try {
        const { data: closed } = await checkIfStoreIsNotPermanentlyClosed(offlineStoreId, getSignal());
        if (closed) {
          setPromotionStoreId('');
        } else {
          setPromotionStoreId(offlineStoreId);
          getStoreAndSetLocalState(offlineStoreId);
        }
      } catch (error) {
        console.log('Could not get closed store', error);
      }
    }
  };

  // Wait for the customer: running before it loads and again once it has doubles the store requests on every load
  useEffect(() => {
    if (!customer) return;
    getStoreAndSetLocalStateFromLocalStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.isAnonymous]);
};

export default useStoreAndLocaleState;
